import React, { Fragment } from 'react';

import { Languages } from '../components/languages';


export default class MonetaWebResult extends React.Component {
    constructor(props) {
        super(props);
        this.le = Languages.MonetaWebResult[Languages.selectedLanguage];

        const params = new URLSearchParams(window.location.search);
        this.state = {
            result: params.get('result')
        };

        setTimeout(() => {
            try {
                if (this.state.result == 'APPROVED' || this.state.result == 'CAPTURED')
                    window.opener.monetaWebResultHandler(true);
                else
                    window.opener.monetaWebResultHandler(false);
            }
            catch (e) {
                console.log("handleMonetaResponse exception.", e);
            }
        }, 300);

    }
    render() {

        let title = this.le.ko;
        let messageDesc = this.le.koMessage;       
        let classIcon = "payment-ko";

        if (this.state.result == 'APPROVED' || this.state.result == 'CAPTURED') {
            title = this.le.ok;
            messageDesc = this.le.okMessage;
            classIcon = "payment-ok";
        }
       
        return (
            <div class="payment-result-container">
                <p>{title}</p>
                <p>{messageDesc}</p>
            </div>
        );
        
    }
}

